/* visual-ingredient-fix-1002 (founder ordered 2026-10-02). Small, site-wide mobile polish; styles live in
   assets/bal-design-polish.css under the same tag. No tracking, no consent logic, no network.
   1. Article tables: wrap each in a sideways-scroll region (no mid-word breaks, 4+ columns scroll on phones).
   2. PDP sticky Add-to-Cart bar: expose its covered height so the chat launcher / pill sit above it.
   3. Phones: tuck the chat launcher while the reader scrolls down through content; it returns on any
      upward scroll, at the top of the page and near the bottom. */
(function () {
  'use strict';
  var root = document.documentElement;

  function wrapTables() {
    var tables = document.querySelectorAll('.bal-article__body table');
    Array.prototype.forEach.call(tables, function (t) {
      var parent = t.parentElement;
      if (!parent || parent.classList.contains('bal-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'bal-table-scroll';
      var first = t.rows && t.rows[0];
      var cols = first ? first.cells.length : 0;
      if (cols >= 4) wrap.classList.add('bal-table-scroll--wide');
      parent.insertBefore(wrap, t);
      wrap.appendChild(t);
    });
    markScrollable();
  }

  function markScrollable() {
    var wraps = document.querySelectorAll('.bal-article__body .bal-table-scroll');
    Array.prototype.forEach.call(wraps, function (w) {
      var scrolls = w.scrollWidth > w.clientWidth + 1;
      if (scrolls) {
        w.setAttribute('tabindex', '0');
        w.setAttribute('role', 'region');
        var cap = w.querySelector('caption');
        w.setAttribute('aria-label', cap && cap.textContent.trim() ? cap.textContent.trim() : 'Table (scrolls sideways)');
      } else {
        w.removeAttribute('tabindex');
        w.removeAttribute('role');
        w.removeAttribute('aria-label');
      }
    });
  }

  function watchStickyBar() {
    var bar = document.getElementById('v4-pdp-sticky-bar');
    if (!bar) return;
    function sync() {
      var up = bar.classList.contains('--visible');
      if (up) {
        /* layout height: the class flips before the slide-in transform finishes */
        var cover = Math.round(bar.offsetHeight || 0);
        if (cover > 0) root.style.setProperty('--bal-sticky-cover', cover + 'px');
      }
      root.classList.toggle('bal-sticky-up', up);
    }
    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', sync, { passive: true });
  }

  function chatTuck() {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (!mq.matches) { root.classList.remove('bal-chat-tuck'); lastY = y; return; }
      var nearTop = y < 300;
      var nearBottom = window.innerHeight + y > document.documentElement.scrollHeight - 240;
      if (nearTop || nearBottom || y < lastY - 6) {
        root.classList.remove('bal-chat-tuck');
      } else if (y > lastY + 6) {
        root.classList.add('bal-chat-tuck');
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  }

  function init() {
    wrapTables();
    watchStickyBar();
    chatTuck();
    window.addEventListener('resize', markScrollable, { passive: true });
    window.addEventListener('load', markScrollable);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
